import React from 'react';
import { LoadingSpinner } from '../../../components';
import { FaDollarSign } from 'react-icons/fa';
import moment from 'moment';

const ByDateMobile = (props) => {
    const { showData, isLoading, renderTransactionPerson } = props;
    return (
        <div className='relative'>
            {isLoading ? <LoadingSpinner /> :
                <div className="flex flex-col gap-3 px-1 pb-10 sm:px-0">
                    {showData.length > 0 ? (
                        showData.map((item, index) => {
                            const { from, to, balance } = renderTransactionPerson(
                                item.createdBy,
                                item.transactionType,
                                item.inward,
                                item.outward,
                                item.description
                            );

                            return (
                                <div
                                    key={index}
                                    className="rounded-2xl border border-customAccent/15 bg-white/90 px-4 py-3 shadow-md shadow-customAccent/10 transition-all hover:shadow-lg dark:border-customSurface dark:bg-customSurface dark:text-customHeading"
                                >
                                    <div className="flex items-start justify-between gap-4">
                                        <div className="mt-[2px] flex items-center justify-center">
                                            <div className="rounded-full bg-customAccentBlue/90 p-2 shadow-sm shadow-customAccentBlue/40 dark:bg-customAccent">
                                                <FaDollarSign size={14} className="text-white" />
                                            </div>
                                        </div>
                                        <div className="flex-1 space-y-1">
                                            <p className="text-[11px] font-medium uppercase tracking-wide text-customSecondaryText">
                                                {moment(item.createdDate).format("DD-MM-YYYY hh:mm A")}
                                            </p>
                                            <div className="flex justify-between">
                                                <h3 className="text-sm font-semibold text-customInk dark:text-customHeading">
                                                    {item.transactionType}
                                                </h3>
                                            </div>
                                            {item.description && (
                                                <p className="text-xs font-medium text-customSecondaryText dark:text-customMuted">{item.description}</p>
                                            )}
                                        </div>
                                        <div className="text-right">
                                            <p className="text-base font-bold text-customInk dark:text-customHeading">
                                                {balance.toLocaleString("en-US")}
                                            </p>
                                            <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted">After Balance</p>
                                            <p className="text-sm font-semibold text-customAccentBlue dark:text-customHeading">
                                                {item.balance.toLocaleString("en-US")}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="mt-3 flex flex-wrap items-center gap-4 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
                                        <span>
                                            From: <span className="text-customFontLightGreen dark:text-customVibrantGreen">{from}</span>
                                        </span>
                                        <span>
                                            To: <span className="text-customFontVoilet">{to}</span>
                                        </span>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="py-12 text-center text-sm text-customSecondaryText dark:text-customMuted">
                            <p>No transactions found for the selected date.</p>
                        </div>
                    )}
                </div>

            }
        </div>
    )
}


export default ByDateMobile;
